/**
 * `registerType: 'autoUpdate'` (vite.config.ts) fa sì che il nuovo service worker chiami da
 * solo skipWaiting()/clientsClaim() e prenda il controllo in background — ma un tab già aperto
 * continua a eseguire il vecchio bundle React in memoria finché non viene ricaricato. Su un
 * tablet a bordo macchina il tab resta aperto per giorni, quindi senza questo reload esplicito
 * un deploy nuovo non arriva mai a schermo (era già successo il 17/07, causa diversa: allora era
 * un bug nginx sulla cache del file sw.js, qui è la totale assenza di logica di reload).
 */
export function setupServiceWorkerAutoReload(): void {
  if (!('serviceWorker' in navigator)) return;

  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  navigator.serviceWorker.ready.then(registration => {
    setInterval(() => { void registration.update(); }, 60_000);
  });
}
